import { render, staticRenderFns } from "./Maddox.vue?vue&type=template&id=52a6674b&scoped=true&"
import script from "./Maddox.vue?vue&type=script&lang=js&"
export * from "./Maddox.vue?vue&type=script&lang=js&"
import style0 from "./Maddox.vue?vue&type=style&index=0&id=52a6674b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6674b",
  null
  
)

export default component.exports